import { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

const useTags = () => {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        setLoading(true);
        const tagsCollection = collection(db, 'tags');
        const snapshot = await getDocs(tagsCollection);
        
        const tagsData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setTags(tagsData);
        setError(null);
      } catch (err) {
        console.error('Error fetching tags:', err);
        setError('Failed to fetch tags');
      } finally {
        setLoading(false);
      }
    };

    fetchTags();
  }, []);

  const getTagById = (tagId) => {
    return tags.find(tag => tag.id === tagId);
  };

  const getTagsByIds = (tagIds) => {
    if (!Array.isArray(tagIds)) return [];
    return tags.filter(tag => tagIds.includes(tag.id));
  };

  const getTagNamesByIds = (tagIds) => {
    if (!Array.isArray(tagIds)) return [];
    return tags
      .filter(tag => tagIds.includes(tag.id))
      .map(tag => tag.name);
  };

  return {
    tags,
    loading,
    error,
    getTagById,
    getTagsByIds,
    getTagNamesByIds
  };
};

export default useTags;
